import React from 'react';
import { useParams } from 'react-router-dom';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import Button from '@ff/ui/Button';
import Heading from '@ff/ui/Heading';
import Modal from '@ff/ui/Modal';
import _ from '../../constants/gettext';
import constants from '../../layouts/NavContentSummaryLayout/constants';
import url from '../../utils/url';
import appHandler from '../../utils/appHandlers';
import Icon from '@ff/ui/Icon';
import zIndices from '../../utils/zIndices';

const FullScreen = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '80vw',

  backgroundColor: theme.colors.white,
  overflow: 'auto',

  [theme.mediaQueries.md]: {
    width: '600px',
    height: '500px'
  }
}));

const Content = styled(Box)({
  minHeight: '500px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '44px',
  width: '100%',
  height: '100%',
});

// Allow button to match heading width
const MatchContentWidth = Box;

export default function SuccessConfirmation({ open, confirmationNum }) {
  const isApp = url.isAppOnly();

  const { region } = useParams<{ region: string }>();

  const goToMyDesigns = () => {
    if (isApp) {
      setTimeout(appHandler.getHandlerByKey('OpenVehicleCollection'), 10);
    } else {
      // Redirect to phoenix
      window.location.href = `/${region}/MyFF/designs/details/${confirmationNum}`;
    }
  }

  const closeConfigurator = () => {
    if (isApp) {
      setTimeout(appHandler.getHandlerByKey('CloseConfigurator'), 10);
    }
  }

  // show below menubar
  return (
    <Modal
      open={open}
      backdrop
      zIndex={zIndices['modalBehind']}
      onClose={closeConfigurator}
      closeIcon={isApp}
      closeIconProps={{ color: 'white', marginTop: '50px' }}
    >
      <FullScreen>
        <Content>
          <Box my="50px">
            <Icon
              fontSize="124px"
              color="coolGrey"
              name="ff-icon-check_circle_outline"
            />
          </Box>
          <MatchContentWidth>
            <Heading.Responsive query={{ _: 'H5', sm: 'H3' }}>{_('LABEL_CONFIGURATION_SAVED')}</Heading.Responsive>
            <Button
              variant='dark'
              fullWidth
              height={constants.BUTTON_HEIGHT}
              marginBottom={{ _: 0, md: '17px' }}
              marginTop={{ _: '24px' }}
              onClick={goToMyDesigns}
            >
              {/* App goes to vehicle collection; web goes to design details */}
              {
                isApp ?
                  _('LABEL_GO_TO_MY_VEHICLE_COLLECTION') :
                  _('LABEL_GO_TO_MY_DESIGN')
              }
            </Button>
          </MatchContentWidth>
        </Content>
      </FullScreen>
    </Modal>
  );
}
